import { VrApp } from './VrApp';

window.vrapp = new VrApp();

window.vrapp.GITCOMMIT = process.env.VUE_APP_GITCOMMIT;

export default window.vrapp;